export const authDataTypes = {
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT",
}